var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house-window 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3478 6.18421L13.0977 2.64121C11.8235 1.78171 10.1765 1.78171 8.90225 2.64121L3.653 6.18421C2.618 6.88171 2 8.04346 2 9.29296V16.25C2 18.3177 3.68225 20 5.75 20H16.25C18.3177 20 20 18.3177 20 16.25V9.29296C20 8.04421 19.382 6.88171 18.3478 6.18421ZM14 14C14 14.8272 13.3273 15.5 12.5 15.5H9.5C8.67275 15.5 8 14.8272 8 14V11C8 10.1727 8.67275 9.49996 9.5 9.49996H12.5C13.3273 9.49996 14 10.1727 14 11V14ZM12.5 11L12.5015 14H9.5V11H12.5Z",
    fill: "#DC7BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.1748636a1183d4f0fe09ee4d83c2d64c.svg";
export { ForwardRef as ReactComponent };